import { Note } from "./Note";
import { SectionCard } from "./SectionCard";
import styles from "./TrainingSection.module.scss";
import { TutorialButton } from "./TutorialButton";

export function TrainingSection() {
  return (
    <SectionCard
      id="training"
      ariaLabelledby="training-h"
      title="Training"
      description="Choose the path that fits your team — live sessions, office hours, or on-demand recordings."
    >
      <div className={styles.trainGrid}>
        {/* Office Hours */}
        <section
          className={`${styles.tierCard} ${styles.highlight}`}
          aria-labelledby="oh-h"
        >
          <h3 id="oh-h" className={styles.tierTitle}>
            <span className={styles.pill} aria-hidden="true">
              ★
            </span>
            Office Hours
          </h3>
          <p className={styles.meta}>
            Every <strong>2 weeks</strong> on <strong>Wednesday</strong> <br />
            from <strong>10:30–11:00 AM PT</strong>.
          </p>

          <div className={styles.ohNext} aria-live="polite">
            <span>Next session:</span>
            <time id="oh-next-date" />
            <span
              id="oh-countdown"
              style={{ fontVariantNumeric: "tabular-nums" }}
            />
          </div>

          <div className={styles.btnRow}>
            <TutorialButton
              to="https://us06web.zoom.us/j/88145737418"
              offsite
              size="md"
            >
              Join Office Hours (Zoom)
            </TutorialButton>
          </div>
        </section>

        {/* Live Team Sessions */}
        <section
          className={styles.tierCard}
          aria-labelledby="training-sessions-h"
        >
          <h3 id="training-sessions-h" className={styles.tierTitle}>
            <span className={styles.pill} aria-hidden="true">
              ✓
            </span>
            Live Team Sessions
          </h3>
          <p className={styles.meta}>
            Book a dedicated, hands-on walkthrough tailored to your firm.
          </p>
          <div className={styles.btnRow}>
            <TutorialButton
              to="https://calendly.com/briefpointceo/briefpoint-overview"
              offsite
              size="lg"
            >
              Schedule Private Training
            </TutorialButton>
          </div>
          <Note>
            Tip: Add your colleagues as Guests to the invite so everyone can
            join the same session.
          </Note>
        </section>
      </div>

      <div style={{ gridColumn: "span 12" }}>
        <div className={styles.grid} />
      </div>
    </SectionCard>
  );
}
